<template>
  <Btn
    tag="button"
    :disabled="loading"
    :size="size"
    :variant="Variant.upgrade"
    data-test-id="upgrade-account"
    :data-expedite="expedite ? '1' : '0'"
    icon="arrowRight"
    icon-position="right"
    @click="enableUserSubscriptionItem"
  >
    {{ loading ? 'Loading' : 'Add user plan' }}
  </Btn>
</template>
<script setup lang="ts">
import type { AddonPagePages } from '../../../lib/services/helpers';

import { navigateTo } from '#imports';
import { ref } from 'vue';

import { useStore3 } from '../../../store/main';
import { storeToRefs } from 'pinia';
import Btn from '../../form/Btn.vue';
import { Variant } from '../../../store/types';
import { useNuxtApp } from '#imports';
import { getUpgradePageAddonUrl } from '../../../lib/services/upgradeLinks';
const { $captureEvent: captureEvent } = useNuxtApp();

const store3 = useStore3();
const loading = ref<boolean>(false);

const props = withDefaults(
  defineProps<{
    size: 'md' | 'sm';
    expedite: boolean;
  }>(),
  {
    size: 'sm',
  },
);

const { subscription } = storeToRefs(store3);
const enableUserSubscriptionItem = async () => {
  loading.value = true;
  const params: AddonPagePages = {
    expedite: props.expedite ? '1' : null,
  };
  captureEvent('click_upgrade_addon_button', {
    addon: 'user_plan',
    hasSubscription: !!subscription.value,
  });
  await navigateTo(getUpgradePageAddonUrl('users', params));
};
</script>
